// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c047b3a8","703":"b9dfefdb"}[chunkId] + ".chunk.js";
};